import type { JSX } from 'react';
import type { ExternalReferralContentKeys } from '@common/validation/customControls/externalReferral';
import type { HearingLossAssessmentDataV3 } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/hearingLossAssessmentV3';
import type { ContentComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { Beoordeling } from '@common/validation/customControls/hearingLoss/hearingLossAssessment/utils';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { HearingLossAssessmentBijgevoegdeInformatie } from './HearingLossAssessmentBijgevoegdeInformatie';

export function HearingLossAssessmentReadV3(): JSX.Element {
    const {
        processActivity: { customControlData },
    } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents(customControlData)} />;
}

export function getComponents(
    customControlData: HearingLossAssessmentDataV3
): ContentComponentsMap<ExternalReferralContentKeys> {
    const map: ContentComponentsMap<ExternalReferralContentKeys> = new Map();

    if (customControlData.beoordeling === Beoordeling.nietPluis) {
        map.set('bijgevoegde_informatie', <HearingLossAssessmentBijgevoegdeInformatie />);
    }

    return map;
}
